/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentCorpoCancelSubscriptionMutationVariables = {|
  corpoRef: string,
  atPeriodEnd?: ?boolean,
  force?: ?boolean,
|};
export type PaymentCorpoCancelSubscriptionMutationResponse = {|
  +payment: ?{|
    +corpo: ?{|
      +res: ?{|
        +code: number,
        +message: string,
        +data: ?any,
      |}
    |}
  |}
|};
export type PaymentCorpoCancelSubscriptionMutation = {|
  variables: PaymentCorpoCancelSubscriptionMutationVariables,
  response: PaymentCorpoCancelSubscriptionMutationResponse,
|};
*/


/*
mutation PaymentCorpoCancelSubscriptionMutation(
  $corpoRef: String!
  $atPeriodEnd: Boolean
  $force: Boolean
) {
  payment {
    corpo {
      res: cancelSubscription(corpoRef: $corpoRef, atPeriodEnd: $atPeriodEnd, force: $force) {
        code
        message
        data
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atPeriodEnd"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "corpoRef"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "force"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PaymentMutation",
    "kind": "LinkedField",
    "name": "payment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentCorpoMutation",
        "kind": "LinkedField",
        "name": "corpo",
        "plural": false,
        "selections": [
          {
            "alias": "res",
            "args": [
              {
                "kind": "Variable",
                "name": "atPeriodEnd",
                "variableName": "atPeriodEnd"
              },
              {
                "kind": "Variable",
                "name": "corpoRef",
                "variableName": "corpoRef"
              },
              {
                "kind": "Variable",
                "name": "force",
                "variableName": "force"
              }
            ],
            "concreteType": "PaymentPaymentPayload",
            "kind": "LinkedField",
            "name": "cancelSubscription",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "data",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PaymentCorpoCancelSubscriptionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PaymentCorpoCancelSubscriptionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "bf7148494e90437d9748e7e556e1ea52",
    "id": null,
    "metadata": {},
    "name": "PaymentCorpoCancelSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation PaymentCorpoCancelSubscriptionMutation(\n  $corpoRef: String!\n  $atPeriodEnd: Boolean\n  $force: Boolean\n) {\n  payment {\n    corpo {\n      res: cancelSubscription(corpoRef: $corpoRef, atPeriodEnd: $atPeriodEnd, force: $force) {\n        code\n        message\n        data\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '557c418d618c1c1f77cab49a99ac07fb';

module.exports = node;
